import { render, staticRenderFns } from "./comp-2.vue?vue&type=template&id=0889ef62&scoped=true"
import script from "./comp-2.vue?vue&type=script&lang=js"
export * from "./comp-2.vue?vue&type=script&lang=js"
import style0 from "./comp-2.vue?vue&type=style&index=0&id=0889ef62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889ef62",
  null
  
)

export default component.exports